import { Flex } from "rebass/styled-components"
import styled from "styled-components"
import '@szhsin/react-menu/dist/core.css';
import TextEditorEmbed from "./TextEditorEmbed";
import { MutationFunctionOptions, DefaultContext, ApolloCache, FetchResult } from "@apollo/client";
import { IProviderReassignConversationOutput, IProviderReassignConversationInput, IProviderChangeStatusConversationOutput, IProviderChangeStatusConversationInput } from "../../../graphql/types/mutations/conversation";

const Wrapper = styled(Flex)`
  position: absolute;
  bottom: 40px;
  left: 0;
  width: calc(100%);
  justify-content: center;
  align-items: center;
`

const EmbedInputBarMaximized: React.FC<{
  onDiscard: () => void
  isNote: boolean
  onTags: () => void
  conversationId: string
  isPatientConvo:boolean
  reassignConversation: (options?: MutationFunctionOptions<IProviderReassignConversationOutput, IProviderReassignConversationInput, DefaultContext, ApolloCache<any>> | undefined) => Promise<FetchResult<IProviderReassignConversationOutput>>
  changeStatusConversation: (options?: MutationFunctionOptions<IProviderChangeStatusConversationOutput, IProviderChangeStatusConversationInput, DefaultContext, ApolloCache<any>> | undefined) => Promise<FetchResult<IProviderChangeStatusConversationOutput>>

  sendReplyHandler: (html: string, assignTo: number, status: string, attachments?: Array<{
    fileName: string,
    mimeType: string,
    data: string,
    size: number,
  }> | null) => void
}> = ({ sendReplyHandler, onDiscard, isNote, onTags,
  conversationId,
  isPatientConvo,
  reassignConversation,
  changeStatusConversation }) => {
    return (
      <Wrapper>
        <Flex flexDirection={'column'} style={{ position: 'relative', width: '100%' }} id='blabla'>
          <TextEditorEmbed
          isPatientConvo={isPatientConvo}
            conversationId={conversationId}
            reassignConversation={reassignConversation}
            changeStatusConversation={changeStatusConversation}
            isNote={isNote} onDeleteHandler={onDiscard} sendReplyHandler={sendReplyHandler} onTags={onTags} />
        </Flex>
      </Wrapper>
    )
  }

export default EmbedInputBarMaximized